import React from "react";
// core components
import IndexNavbar from "components/Navbars/IndexNavbar.js";
import Footer from "components/Footer/Footer.js";
import { Container, Row, Col } from "reactstrap";

export default function MinistriesPage() {  
  return ( 
    <>
    <IndexNavbar />
    <div className="section section-typo">
        <img alt="..." className="path" src={require("assets/img/path1.png")} />
        <img
            alt="..."
            className="path path1"
            src={require("assets/img/path3.png")}
        />
        <Container>
        <Row className="justify-content-center">
            <Col lg="12">
            <h1 className="text-center mt-5">Ministérios</h1>
            <Row className="row-grid justify-content-center">
                <Col lg="3">
                <div className="info">
                    <div className="icon icon-primary">
                    <i className="fa-regular fa-comments" />
                    </div>
                    <h4 className="info-title">Aconselhamento</h4>
                    <hr className="line-primary" />
                    <p>
                    O Ministério de Aconselhamento tem como propósito acolher e orientar pessoas por meio da Palavra de Deus. 
Somos um ministério composto por homens e mulheres experimentados na fé, que decidiram dedicar a sua vida a servir o próximo com base na sabedoria e no amor de Cristo.
Todas as vezes que você sentir que precisa de oração, orientação e acompanhamento em áreas ou situações da sua vida, você poderá contar com este ministério.
                    </p>
                </div>
                </Col>
                <Col lg="3">
                <div className="info">
                    <div className="icon icon-success">
                    <i className="fa-solid fa-person-military-rifle" />
                    </div>
                    <h4 className="info-title">Army</h4>
                    <hr className="line-warning" />
                    <p>
                    Mantemos a segurança e a ordem durante os cultos, dentro e fora da igreja. 
                    Nossa missão é receber bem a todos. 
                    </p>
                </div>
                </Col>
                <Col lg="3">
                <div className="info">
                    <div className="icon icon-warning">
                    <i className="fa-solid fa-headphones" />
                    </div>
                    <h4 className="info-title">Áudio</h4>
                    <hr className="line-success" />
                    <p>
                    Garantir a qualidade sonora. Operar a mesa de som e demais equipamentos de áudio durante os cultos e eventos. 
Fazer a equalização e ajustes necessários para garantir um som equilibrado. Manter e realizar manutenção preventiva dos equipamentos de áudio. 
Auxiliar na captação e transmissão de áudio para transmissões online
                    </p>
                </div>
                </Col>
            </Row>

            <Row className="row-grid justify-content-center">
                <Col lg="3">
                <div className="info">
                    <div className="icon icon-primary">
                    <i className="fa-solid fa-handshake" />
                    </div>
                    <h4 className="info-title">Business</h4>
                    <hr className="line-primary" />
                    <p>
                    O ministério Business  tem como objetivo levar a visão do reino para o mundo dos negócios, criando network entre pessoas, aprendizado e principalmente levando o amor de Deus através de testemunhos do que Deus tem feito nesse meio.
Tem como ramificação, os eventos da igreja. 
                    </p>
                </div>
                </Col>
                <Col lg="3">
                <div className="info">
                    <div className="icon icon-warning">
                    <i className="fa-solid fa-utensils" />
                    </div>
                    <h4 className="info-title">Cantina</h4>
                    <hr className="line-warning" />
                    <p>
                    Nossa missão é servir, oferecendo mais do que apenas produtos. 
Oferecemos amor e cuidado em cada atendimento.
                    </p>
                </div>
                </Col>
                <Col lg="3">
                <div className="info">
                    <div className="icon icon-success">
                    <i className="fa-solid fa-comments" />
                    </div>
                    <h4 className="info-title">Comunicação</h4>
                    <hr className="line-success" />
                    <p>
                    Responsáveis por transmitir a mensagem do Evangelho de forma criativa e acessível, fortalecendo o posicionamento e a identidade da nossa igreja. 
                    Cuidamos da comunicação interna e externa, garantindo que cada conteúdo reflita a visão e os valores da Conectados.
                    </p>
                </div>
                </Col>
            </Row> 


            <Row className="row-grid justify-content-center">
                <Col lg="3">
                <div className="info">
                    <div className="icon icon-primary">
                    <i className="fa-solid fa-photo-film" />
                    </div>
                    <h4 className="info-title">DataShow</h4>
                    <hr className="line-primary" />
                    <p>
                    O Datashow fornece um suporte visual nos cultos e eventos da igreja, são transmitidos no telão: letra dos louvores, os versículos da bíblia, imagens e vídeos, avisos e informações relevantes, que contribuam para a a experiência do culto ser mais dinâmica.
                    </p>
                </div>
                </Col>
                <Col lg="3">
                <div className="info">
                    <div className="icon icon-warning">
                    <i className="fa-solid fa-graduation-cap" />
                    </div>
                    <h4 className="info-title">Ensino</h4>
                    <hr className="line-warning" />
                    <p>
                    Despertar um interesse e amor para com o aprendizado da Palavra, manuseá-la bem.
Mostrar que o conhecimento das Escrituras é transformador.
Tudo muda com o conhecimento e obediência. 
                    </p>
                </div>
                </Col>
                <Col lg="3">
                <div className="info">
                    <div className="icon icon-success">
                    <i className="fa-solid fa-people-roof" />
                    </div>
                    <h4 className="info-title">Family</h4>
                    <hr className="line-success" />
                    <p>
                    Conectados Family é um ministério dedicado ao fortalecimento e restauração de casais e famílias por meio de cursos, aconselhamentos e ministrações. Baseados nos princípios cristãos, buscamos proporcionar ensinamentos transformadores que promovam relacionamentos saudáveis, alegres e edificados sobre a Palavra de Deus.
                    </p>
                </div>
                </Col>
            </Row> 


            <Row className="row-grid justify-content-center">
                <Col lg="3">
                <div className="info">
                    <div className="icon icon-primary">
                    <i className="fa-solid fa-chess-king" />
                    </div>
                    <h4 className="info-title">Homens</h4>
                    <hr className="line-primary" />
                    <p>
                    Conectar os homens ao seu propósito. Conduzi-los para que entendam seu papel dentro da família, igreja e sociedade. 
                    </p>
                </div>
                </Col>
                <Col lg="3">
                <div className="info">
                    <div className="icon icon-warning">
                    <i className="fa-solid fa-person-praying" />
                    </div>
                    <h4 className="info-title">Intercessão</h4>
                    <hr className="line-warning" />
                    <p>
                    Preparar o ambiente espiritual através de orações para que a igreja receba as ministrações.
                    </p>
                </div>
                </Col>
                <Col lg="3">
                <div className="info">
                    <div className="icon icon-success">
                    <i className="fa-solid fa-child" />
                    </div>
                    <h4 className="info-title">Kids</h4>
                    <hr className="line-success" />
                    <p>
                    O Ministério Kids existe para ensinar as crianças a conhecer, amar e seguir a Cristo, proporcionando uma base sólida na palavra de Deus.
Nosso objetivo é criar um ambiente acolhedor e envolvente, onde por meio de lições criativas e atividades dinâmicas, as crianças possam desenvolver uma conexão genuína com Cristo, aprendendo a viver como discípulos e a refletir o amor de Deus em suas vidas diárias.
                    </p>
                </div>
                </Col>
            </Row>

            <Row className="row-grid justify-content-center">
                <Col lg="3">
                <div className="info">
                    <div className="icon icon-primary">
                    <i className="fa-solid fa-people-group" />
                    </div>
                    <h4 className="info-title">GC's</h4>
                    <hr className="line-primary" />
                    <p>
                    Nossos Grupos de Conexão existem para fortalecer a edificação, o discipulado e a comunhão entre os membros da Conectados.
                    </p>
                </div>
                </Col>
                <Col lg="3">
                <div className="info">
                    <div className="icon icon-warning">
                    <i className="fa-solid fa-chess-queen" />
                    </div>
                    <h4 className="info-title">Mulheres</h4>
                    <hr className="line-warning" />
                    <p>
                    Ministério para conectar às mulheres ao seu propósito. 
                    </p>
                </div>
                </Col>
                <Col lg="3">
                <div className="info">
                    <div className="icon icon-success">
                    <i className="fa-solid fa-hand-holding-heart" />
                    </div>
                    <h4 className="info-title">Social</h4>
                    <hr className="line-success" />
                    <p>
                    Promovemos ações sociais, levando o amor e a Palavra através de atos de serviço, doações e evangelismo.
O ministério social visa servir a igreja e a comunidade. Como Deus nos amou, devemos nós também amar uns aos outros.
                    </p>
                </div>
                </Col>
            </Row>

            <Row className="row-grid justify-content-center">
                <Col lg="3">
                <div className="info">
                    <div className="icon icon-primary">
                    <i className="fa-solid fa-masks-theater" />
                    </div>
                    <h4 className="info-title">Teatro</h4>
                    <hr className="line-primary" />
                    <p>
                    É um Ministério de Adoração  e evangelismo que atua através das Artes, com produções de peças teatrais e ações internas e externas (escolas e comunidades).
                    </p>
                </div>
                </Col>
                <Col lg="3">
                <div className="info">
                    <div className="icon icon-warning">
                    <i className="fa-solid fa-hand-peace" />
                    </div>
                    <h4 className="info-title">Teens</h4>
                    <hr className="line-warning" />
                    <p>
                    O Conectados Teens é o ministério dos Adolescentes, entre 12 a 16 anos. 
Promovemos a inclusão dos adolescentes na igreja, os fazendo entender que são parte fundamental dela desde já! 
Acreditamos que os adolescentes são reforços para que tenhamos uma igreja forte e geracional.
No Teens temos 4 pilares: Palavra, Servir, Amizade e Comunhão. 
                    </p>
                </div>
                </Col>
                <Col lg="3">
                <div className="info">
                    <div className="icon icon-success">
                    <i className="fa-solid fa-tv" />
                    </div>
                    <h4 className="info-title">TV e Iluminação</h4>
                    <hr className="line-success" />
                    <p>
                    O Conectados TV e Iluminação é o ministério responsável por levar a Igreja Conectados além das quatro paredes físicas, alcançando pessoas em qualquer lugar do mundo através da transmissão ao vivo de cultos e eventos; cremos que temos uma igreja on-line. 
                    </p>
                </div>
                </Col>
            </Row>

            <Row className="row-grid justify-content-center">
                <Col lg="3">
                <div className="info">
                    <div className="icon icon-primary">
                    <i className="fa-solid fa-door-open" />
                    </div>
                    <h4 className="info-title">Welcome</h4>
                    <hr className="line-primary" />
                    <p>
                    O Ministério Welcome é responsável por recepcionar e orientar todas as pessoas, dando atenção especial aos visitantes, para que se sintam bem acolhidos e integrados à família Conectados.  
                    </p>
                </div>
                </Col>
                <Col lg="3">
                <div className="info">
                    <div className="icon icon-warning">
                    <i className="fa-solid fa-hands-holding" />
                    </div>
                    <h4 className="info-title">Worship</h4>
                    <hr className="line-warning" />
                    <p>
                    Sua principal função é criar um ambiente onde possamos nos conectar com Deus através da expressão de uma adoração em espírito e em verdade.
Conduzimos a congregação à adorar e à exaltar ao Senhor
Suas frentes são:  música, dança, artes e também a linguagem de sinais (libras)
                    </p>
                </div>
                </Col>
                <Col lg="3">
                <div className="info">
                    <div className="icon icon-success">
                    <i className="fa-solid fa-users-viewfinder" />
                    </div>
                    <h4 className="info-title">Youth</h4>
                    <hr className="line-success" />
                    <p>
                    Ministério que trabalha com jovens entre 17 à 25 anos, abordando temas que refletem suas necessidades e desafios.
Nosso objetivo é: proporcionar um ambiente seguro e acolhedor, oferecer apoio emocional e espiritual para que cada jovem cresça em sua caminhada.
Identificar, capacitar, desenvolver habilidades e proporcionar oportunidades para que todos aprendam e se sintam pertencentes.
                    </p>
                </div>
                </Col>
            </Row>

            </Col>
        </Row>
        </Container>    
    </div>
    <Footer />
    </>
  );
}
